
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/austin-shade",
      function () {
        return require("private-next-pages/stories/austin-shade.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/austin-shade"])
      });
    }
  